module.exports = __webpack_public_path__ + "3767bfb3c8bf74b226404cc0cd8b0f8c.jpg";